// ─── Beta CTA Visibility Toggle ──────────────────────────────────────────────
//
// Controls whether the beta CTA block is visible on the landing page.
//
// false (current) → CTA is hidden. The page shows the coming-soon email form only.
// true            → A "Try the beta now!" button appears, linking to https://beta.envheaven.com
//
// To flip: change SHOW_BETA_CTA to true below, rebuild, and redeploy.
//
export const SHOW_BETA_CTA = false;
